module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page-title":"Bulletins"},"ar":{"page-title":"النشرات"}}')
  delete Component.options._Ctor
}
